export default (open, title, { event = "open::images-modal", ...options }) => ({
    open,
    event,
    title,
    tab: 0,
    key: null,
    allImages: [],
    currentImages: null,
    favoriteImages: [],
    downloading: [],

    init() {
        window.addEventListener(event, ({ detail }) => this.set(detail));
    },

    set({ images, key = null }, open = true) {
        this.open = open;
        this.key = key;

        this.currentImages = Object.values(images).flatMap((image) => image);
        this.allImages = Object.assign([], this.currentImages);
        this.favoriteImages = Object.assign([], this.currentImages).filter(
            (image) => image.favorite == true
        );

        this.$nextTick(() => this.refresh(images));
    },

    favorite() {
        this.tab = 1;

        this.currentImages = this.favoriteImages;
        this.refresh(this.currentImages);
    },

    all() {
        this.tab = 0;

        this.currentImages = this.allImages;
        this.refresh(this.currentImages);
    },

    share() {
        this.$wire.share(this.key);
    },

    openSliderPreview(imageId) {
        const position = this.currentImages.findIndex(
            (image) => image.id == imageId
        );

        this.$dispatch("open::slider-preview", [
            this.currentImages,
            position,
            {
                canDownload: _.get(options, "canDownload", false),
                canFavorite: _.get(options, "canFavorite", false),
                imageAttr: _.get(options, "imageAttr", "preview"),
                event: `${this.event}::update`,
                scrollTarget: 'images-modal',
                totalImagesCount: this.currentImages.length,
            },
        ]);
    },

    showPreview({detail}) {
        this.$dispatch('images-tooltip::show', {
            target: detail.target,
            url: detail.data.preview,
            name: detail.data.name
        });
    },

    closePreview() {
        this.$dispatch('images-tooltip::close')
    },

    async download(url, name) {
        if (this.$isMobileSafari()) {
            this.$dispatch("view-photo-modal::open", { url, name });

            this.downloading = this.downloading.filter(
                (downloaded) => downloaded !== name
            );

            return;
        }

        this.downloading.push(name);

        this.$downloadImage(url, name, () => {
            this.downloading = this.downloading.filter(
                (downloaded) => downloaded !== name
            );
        });
    },

    refresh(images = null) {
        this.$dispatch("images-modal::refresh", { images });
    },
});
